/**
 * Enumerates products that categorize knowledge base content.
 *
 * These map 1:1 to Know CMS (where editing is disabled) to
 * allow content filtering against products with some compile
 * time type safety. Do not change the string values without
 * also updating Know CMS.
 *
 * Entries are purposefully alphabetical to allow for deterministic
 * usage of functions like Object.values()
 */
export enum ProductUid {
    GENESYS_CLOUD_CX = 'genesys-cloud-cx',
    GENESYS_ENGAGE_ON_PREM = 'genesys-engage-on-prem',
}

/**
 * Object representing mappings of a {@link ProductUid} to a human-readable display name
 */
export const ProductDisplayName: Record<ProductUid, string> = {
    [ProductUid.GENESYS_CLOUD_CX]: 'Genesys Cloud',
    [ProductUid.GENESYS_ENGAGE_ON_PREM]: 'Genesys Engage on-premises',
};
